export const contestActionTypes = {
  SET_CONTEST_BALANCE_LOADING: "SET_CONTEST_BALANCE_LOADING",
  SET_CONTEST_BALANCE_SUCCESS: "SET_CONTEST_BALANCE_SUCCESS",
  SET_CONTEST_BALANCE_ERROR: "SET_CONTEST_BALANCE_ERROR",
  CONTEST_CLOSED_LOADING: "CONTEST_CLOSED_LOADING",
  CONTEST_CLOSED_SUCCESS: "CONTEST_CLOSED_SUCCESS",
  CONTEST_CLOSED_ERROR: "CONTEST_CLOSED_ERROR",
  CONTEST_LIVE_LOADING: "CONTEST_LIVE_LOADING",
  CONTEST_LIVE_SUCCESS: "CONTEST_LIVE_SUCCESS",
  CONTEST_LIVE_ERROR: "CONTEST_LIVE_ERROR",
  CONTEST_EVENT_LOADING: "CONTEST_EVENT_LOADING",
  CONTEST_EVENT_SUCCESS: "CONTEST_EVENT_SUCCESS",
  CONTEST_EVENT_ERROR: "CONTEST_EVENT_ERROR",
  SET_CONTEST_VISIBLE: "SET_CONTEST_VISIBLE",
};
